(function() {
    'use strict';
    angular.module('sgnmrApp').controller('HistorialNormativoController', HistorialNormativoController);
    HistorialNormativoController.$inject = ['norma', 'historial', 'PublicNorma', 'Principal'];

    function HistorialNormativoController(norma, historial, PublicNorma, Principal) {
        var vm = this;
        vm.norma = norma;
        vm.historial = historial;
        vm.isAuthenticated = Principal.isAuthenticated;

        // Formato del archivo (PDF, Word...) para elegir su icono.
        function formatoDeDocumento(nombre) {
            var ext = (nombre || '').split('.').pop().toLowerCase();
            if (ext === 'pdf') { return {icon: 'icon-pdf', color: '#ff0000', etiqueta: 'PDF'}; }
            if (ext === 'docx') { return {icon: 'icon-doc-word', color: '#3B5998', etiqueta: 'Word'}; }
            return {icon: 'icon-enlaces-ligas', color: '#003041', etiqueta: 'Documento'};
        }

        // Cada entrada trae sus propios documentos, con la misma llamada que ya
        // usa la vista de una norma individual. Los de tipo ACTUALIZADO van a su propia
        // columna; el resto, a la columna "Documento".
        vm.historial.forEach(function(entrada) {
            entrada.documentos = [];
            entrada.documentoActualizado = null;

            PublicNorma.getDocuments({id: entrada.id}, function(documentos) {
                documentos.forEach(function(doc) {
                    doc.formato = formatoDeDocumento(doc.nombre);
                    if (doc.tipo === 'ACTUALIZADO') {
                        // Solo debe haber uno; si por error hubiera más, se toma el primero
                        if (!entrada.documentoActualizado) {
                            entrada.documentoActualizado = doc;
                        }
                    } else {
                        entrada.documentos.push(doc);
                    }
                });
            });
        });
    }
})();
